import React from 'react';

const MailIcon = ({
  className = 'mail-icon',
  fill = '#CCC',
  height,
  width,
  title = 'Mail Icon'
}) => (
  <svg
    id='icn-mail'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 36 36'
    height={height}
    width={width}
    className={className}
  >
    <title>{title}</title>
    <path
      fill={fill}
      d='M0,3.6V32.4H36V3.6ZM4,7.2H32L18,16h0Zm28.4,4V28.8H3.6V11.2l14.4,9h0Z'
    />
  </svg>
);

export default MailIcon;
